import type { CardDesign, Rarity, Sport } from '__generated__/globalTypes';
import type { LineupStyle } from 'components/lobby/ContenderLayout';

import { local } from '.';

export enum SportSelectType {
  ALL_SPORTS = 'allSport',
  FOOTBALL = 'football',
  BASEBALL = 'baseball',
  NBA = 'nba',
}

export const LocalKeys = {
  test: 'test',
  showOnlyGamesWithLinedUpPlayers: 'showOnlyGamesWithLinedUpPlayers',
  sortingOrderSchedule: 'sortingOrderSchedule',
  includeCommonsSchedule: 'includeCommonsSchedule',
  mlbGameViewStats: 'mlbGameViewStats',
  savedHistory: 'savedHistory',
  trackingConsent: 'trackingConsent',
  mlbMonthlyChaseLastPreferredScarcity: 'mlbMonthlyChaseLastPreferredScarcity',
  useRedDotNotification: 'useRedDotNotification',
  useBaseballRedDotNotification: 'useBaseballRedDotNotification',
  useNbaRedDotNotification: 'useNbaRedDotNotification',
  sportLineupStyle: 'sportLineupStyle',
  mlbOffseasonCountdownReminder: 'mlbOffseasonCountdownReminder',
  sport: 'sport',
  lastVisitedEventType: 'lastVisitedEventType',
  navigationSidebarCollapsed: 'navigationSidebarCollapsed',
  myBidsBannerIgnoredBids: 'myBidsBannerIgnoredBids',
  utmCampaign: 'utmCampaign',
  utm_campaign: 'utm_campaign',
  UTM_CAMPAIGN: 'UTM_CAMPAIGN',
  expandLiveEvent: 'expandLiveEvent',
  utm_content: 'utm_content',
  utm_medium: 'utm_medium',
  utm_source: 'utm_source',
  utm_term: 'utm_term',
  traffic_category: 'traffic_category',
  partner: 'partner',
  user: 'user',
  referrer: 'referrer',
  irclickid: 'irclickid',
  invitation_token: 'invitation_token',
  google_clickid: 'google_clickid',
  facebook_clickid: 'facebook_clickid',
  twitter_clickid: 'twitter_clickid',
  tiktok_clickid: 'tiktok_clickid',
  snapchat_clickid: 'snapchat_clickid',
  reddit_clickid: 'reddit_clickid',
  gclid: 'gclid',
  fbclid: 'fbclid',
  twclid: 'twclid',
  ttclid: 'ttclid',
  ScCid: 'ScCid',
  rdt_cid: 'rdt_cid',
  device_fingerprint: 'DEVICE_FINGERPRINT',
  randomSessionId: 'randomSessionId',
  custom_profile_id: 'CUSTOM_PROFILE_ID',
  impact_clickid: 'IMPACT_CLICKID',
  selectedSport: 'selectedSport',
  selectedDesign: 'selectedDesign',
  cardEditionName: 'cardEditionName',
  gqlDebug: 'gql-debug',
  mySorareSelectedSport: 'MySorare.selectedSport',
  arenaRarityFilter: 'arenaRarityFilter',
} as const;

export type LocalStorageEntries = {
  [LocalKeys.test]: any; // any on purpose for testing any values
  [LocalKeys.showOnlyGamesWithLinedUpPlayers]: any;
  [LocalKeys.sortingOrderSchedule]: any;
  [LocalKeys.includeCommonsSchedule]: any;
  [LocalKeys.mlbGameViewStats]: 'fantasy' | 'actual';
  [LocalKeys.savedHistory]: any;
  [LocalKeys.trackingConsent]: boolean;
  [LocalKeys.mlbMonthlyChaseLastPreferredScarcity]: any;
  [LocalKeys.useRedDotNotification]: any;
  [LocalKeys.useBaseballRedDotNotification]: any;
  [LocalKeys.useNbaRedDotNotification]: any;
  [LocalKeys.sportLineupStyle]: Record<Sport, LineupStyle>;
  [LocalKeys.mlbOffseasonCountdownReminder]: any;
  [LocalKeys.sport]: Sport | undefined;
  [LocalKeys.lastVisitedEventType]: any;
  [LocalKeys.navigationSidebarCollapsed]: boolean;
  [LocalKeys.myBidsBannerIgnoredBids]: string[];
  [LocalKeys.expandLiveEvent]: boolean;
  [LocalKeys.utm_campaign]: string;
  [LocalKeys.UTM_CAMPAIGN]: string | undefined;
  [LocalKeys.utmCampaign]: string;
  [LocalKeys.utm_content]: string;
  [LocalKeys.utm_medium]: string;
  [LocalKeys.utm_source]: string;
  [LocalKeys.utm_term]: string;
  [LocalKeys.traffic_category]: string;
  [LocalKeys.partner]: string;
  [LocalKeys.user]: string;
  [LocalKeys.referrer]: string;
  [LocalKeys.irclickid]: string;
  [LocalKeys.gclid]: string;
  [LocalKeys.fbclid]: string;
  [LocalKeys.twclid]: string;
  [LocalKeys.ttclid]: string;
  [LocalKeys.ScCid]: string;
  [LocalKeys.rdt_cid]: string;
  [LocalKeys.invitation_token]: string;
  [LocalKeys.impact_clickid]: string;
  [LocalKeys.google_clickid]: string;
  [LocalKeys.facebook_clickid]: string;
  [LocalKeys.twitter_clickid]: string;
  [LocalKeys.tiktok_clickid]: string;
  [LocalKeys.snapchat_clickid]: string;
  [LocalKeys.reddit_clickid]: string;
  [LocalKeys.custom_profile_id]: string;
  [LocalKeys.device_fingerprint]: string;
  [LocalKeys.randomSessionId]: string;
  [LocalKeys.selectedSport]: 'football' | 'baseball' | 'nba';
  [LocalKeys.selectedDesign]: CardDesign;
  [LocalKeys.cardEditionName]: string;
  [LocalKeys.gqlDebug]: boolean;
  [LocalKeys.mySorareSelectedSport]: SportSelectType;
  [LocalKeys.arenaRarityFilter]: Rarity;
};
export const localStorage = {
  getItem: <K extends keyof LocalStorageEntries>(value: K) =>
    local.getItem(value) as LocalStorageEntries[K],
  setItem: <K extends keyof LocalStorageEntries>(
    key: K,
    value: LocalStorageEntries[K] | null
  ) => local.setItem(key, value),
  removeItem: <K extends keyof LocalStorageEntries>(key: K) =>
    local.removeItem(key),
  key: (index: number) => local.key(index),
  length: local.length,
  clear: local.clear,
};
